import { render, staticRenderFns } from "./Pencil.vue?vue&type=template&id=4512d1d1"
import script from "./Pencil.vue?vue&type=script&lang=js"
export * from "./Pencil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports